import request from '@/utils/http'
import { getQueryString } from '@/utils/tool'
import type { FilterPayload } from '@/views/common/filtrate/filtrate.type'
import { isNull, omitBy } from 'lodash'

/**
 * 根据关键字搜索题目列表
 * @param query 关键字 支持 id 标题 内容
 * @returns
 */
export const searchTopicApi = (page: number, query: string, isReal: any, termId?: string) => {
  let path =
    '/api/posts/getfuzzy?perPage=30&page=' + page + '&content=' + query + '&isReal=' + isReal
  if (termId) {
    path = path + '&termId=' + termId
  }
  return request.get<searchData>(path)
}
export interface searchData {
  total: number
  list: searchList[]
}

export interface searchList {
  id: number
  slugName: string
  categories: number
  hot: number
  title: string
  content: string
  date: number
  examCount: number
  collect: number
  read: number
  like: number
  exam: number
  postNumber: number
  newTopic: number
  updateTopic: number
  questionsId: number
  questionsTypeCode: string
  parentCode: string
  frequency: number
  orderId: number
  practiceCount: number
  /**分类标签 */
  color: number
  /**是否有微课 */
  highfrequencyVideo?: boolean
  listColour: string
}

/**
 * 根据查询条件获取机经列表
 * @param payload 查询条件
 * @returns
 */
export const getTopicListApi = (payload: FilterPayload) => {
  Object.keys(payload).forEach((item) => {
    const key = item as keyof FilterPayload
    // 剔除不影响筛选条件的参数
    if (!payload[key] || payload[key] === '0') {
      if (key === 'isFull') {
        delete payload.isFull
      }
      if (key === 'code') {
        delete payload.code
      }
      if (key === 'updTopic') {
        delete payload.updTopic
      }
      if (key === 'isReal') {
        delete payload.isReal
      }
    }
  })
  return request.get<TopicListData>('/api/postsV2/list', {
    ...payload
  })
}
export interface TopicListData {
  isReal: number | string

  learnCount: number
  start: number
  pageSize: number
  orderBy: string
  posts: Post[]
  randList: Post[]
  uid: string
  total: number
  hotSort?: any
  practiceStatus?: any
  categories: number
  isFull: number
  updateTopic?: number
}

export interface Post {
  id: number
  title: string
  hot: number
  newTopic: number
  updateTopic: number
  practiceCount: number
  date: number
  postModified: number
  exam: number
  read: number
  questionsTypeCode: string
  parentCode: string
  content: string
  postExcerpt: string
  postContentFiltered: string
  color: number
  highfrequencyVideo?: boolean
  questionsId?: number
}

/**
 * 获取考试信息
 * @returns
 */
export const getHierarchyApi = () => {
  return request.post<[any[], Countries]>('/api/dynamic/hierarchy')
}
export interface Countries {
  name: string
  list: List3[]
}

interface List3 {
  countries: string
  list: List2[]
}

interface List2 {
  city: string
  list: (List | List)[]
}

interface List {
  id: number
  place: string
}

/**
 * 提交考过信息
 * @param payload
 * @returns
 */
export const postExamedApi = (payload: {
  attribute: 0
  experience: string
  placeId: number | string
  postId: number
  testTime: number
  type: 1
}) => {
  return request.post('/api/posts/examed', { ...payload })
}

export interface ViewList {
  typeCode: string
  count: number
  hitRate: number
  stabilityRate: number
  highFrequency: number
  proposal: string
  date: string
  newQuestionType: number
  eproposal: string
}

export type CollectLabel = '生词' | '机经' | '精听'
/**
 * 获取收藏夹信息
 * @param label 收藏夹类型
 * @returns
 */
export const getCollectInfoApi = (label: CollectLabel) => {
  return request.get<UserCollectData>('/api/userCollect/queryUserFavorite', {
    label: label
  })
}
export interface UserCollectData {
  userCollectTypes: UserCollectType[]
  userFavoriteCount: number
}

export interface UserCollectType {
  id: number
  label: string
  name: string
  imageUrl: string
  appImgurl: string
  type: number
  userId?: string
  sort: number
  collectCount: number
}

export interface CollectPayload {
  /**收藏夹类型 */
  label: string
  /**收藏夹id */
  id?: number
  /**机经id */
  qid?: number
  /** 收藏夹颜色 */
  color?: number
  /**题型 */
  termName?: string
  word?: string[]
}
export const postCollectApi = (payload: CollectPayload) => {
  return request.post('/api/userCollect/addUserCollect', payload)
}

interface CommentPayload {
  commentType: number
  content: string | number
  parent: number
  postId: number
  postType: number
  questionsId: number
  syncCommunity: number
  answer?: string | null
}
export const reviewAddApi = (payload: CommentPayload) => {
  const source = getQueryString('source') || '机经练习'
  return request.post('/api/questionsComment/add', {
    ...omitBy(payload, isNull),
    source
  })
}

export interface settingData {
  //刷题模式 0：练习模式 1：看题模式
  brushMode: number
  //练习开始方式 0：自动开始 1：手动开始
  learnStartMode: number
  //准备时间 0：关 1：开
  readinessTime: number
  //自动下一题 0：关 1：开
  autoQuestion: number
  //单词自动发音 0：关 1：开
  wordAutoPronounce: number
  //单词默认发音 0：英音 1：美音
  wordDefaultPronounce: number
}

export interface settingInfoData {
  type: number
  //图片地址
  image: string
  //标题
  title: string
  //描述
  desc: string
}

/**
 * 获取用户学习设置图片
 * @returns
 */
export const getSettingImageApi = () => {
  return request.get<settingInfoData[]>('/api/user/querySettingImage')
}

/**
 * 新增or修改用户学习设置
 * @returns
 */
export const saveOrUpdateSettingApi = (body?: settingData) => {
  return request.post<settingData>('/api/user/saveOrUpdateSetting', body)
}

export const workTimeOrCountApi = () => {
  let isFind = false
  const fn = {
    /**计数 1次*/
    countFn: () => {
      request.get('/api/postsV2/saveTimedOrCount', {
        type: 2,
        business: 1
      })
    },
    /**计时 秒 */
    countTime: (s: number) => {
      request.get('/api/postsV2/saveTimedOrCount', {
        type: 1,
        business: s
      })
    }
  }
  if (!isFind) {
    if (!window.localStorage.getItem('token')) {
      return {
        countFn: () => {},
        countTime: () => {}
      }
    }
    request
      .get<{
        isCount: boolean
        isSecond: boolean
        isZoom: boolean
      }>('/api/postsV2/findUserWorkCount')
      .then((res) => {
        isFind = true
        if (!res.data.isCount) {
          fn.countFn = () => {}
        }
        if (!res.data.isSecond) {
          fn.countTime = () => {}
        }
        window.localStorage.setItem('isZoom', JSON.stringify(res.data.isZoom || false))
      })
  }
  // type: 1-计时(秒),2-计数
  return fn
}
